// extracted by mini-css-extract-plugin
export default {"table":"A_qzg4ERCr","group-heading":"D5AdvtiqdI","groupHeading":"D5AdvtiqdI","sub":"uODcMPquam","not-available":"IeCcEbFFj7","notAvailable":"IeCcEbFFj7"};